import { IColumnWidthSetAction } from './types';
import { AT_COLUMN_WIDTH_SET } from './constants';

export const columnWidthSetAction = (
    width: number
): IColumnWidthSetAction => ({
    type: AT_COLUMN_WIDTH_SET,
    width
});
